// url에 쿼리스트링으로 한영 언어에 대한 정보를 담아 주기 위해 필요한 로직
export default function getNextUrl(originUrl) {
  let parsedUrl = originUrl;

  // 끝에 / 없애기
  if (parsedUrl[parsedUrl.length - 1] === '/') {
    parsedUrl = parsedUrl.slice(0, [parsedUrl.length - 1]);
  }

  // 끝에 ? 없으면(쿼리스트링 없으면) ? 붙여주기
  if (parsedUrl.indexOf('?') === -1) {
    parsedUrl += '?';
  }

  const langIdx = parsedUrl.indexOf('lang=');
  if (langIdx !== -1) {
    let startIdx = langIdx;
    let endIdx = langIdx + 7;
    const hasAndatStart = parsedUrl[langIdx - 1] === '&';
    const hasAndatEnd = parsedUrl[langIdx + 7] === '&';
    startIdx = hasAndatStart ? startIdx - 1 : startIdx;
    endIdx = hasAndatEnd ? endIdx + 1 : endIdx;

    if (hasAndatEnd && hasAndatEnd) {
      parsedUrl = parsedUrl.substring(0, startIdx) + '&' + parsedUrl.substring(endIdx);
    } else {
      parsedUrl = parsedUrl.substring(0, startIdx) + parsedUrl.substring(endIdx);
    }
  }

  const endString = parsedUrl[parsedUrl.length - 1];
  if (endString !== '?' && endString !== '&') {
    parsedUrl += '&';
  }

  return parsedUrl;
}
